import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { connect } from 'react-redux'
import type { AnyAction, Dispatch } from 'redux'
import { bindActionCreators } from 'redux'

import * as modalActionCreators from '../store/modal'

function BookTickets({
  modalActions,
}: {
  modalActions: typeof modalActionCreators
}) {
  const [date, setDate] = useState(moment())
  const [maxDate, setMaxDate] = useState(moment().add(2, 'years'))

  useEffect(() => {
    fetch('https://api.miniatur-wunderland.de/v1/maxDate/', {
      method: 'GET',
      mode: 'cors',
    })
      .then((response) => {
        response
          .json()
          .then((data: { maxDate: string }) => {
            setMaxDate(moment(data.maxDate, 'YYYY-MM-DD'))
          })
          .catch((e) => {
            console.warn(e)
          })
      })
      .catch((e) => {
        console.warn(e)
      })
  }, [])

  return (
    <div className="BookTicketsComponent">
      <div className="BookTicketsComponent__Field BookTicketsComponent__Field--visit FormField">
        <div className="FormField__Label">
          {window.jsProps.strings.visitDate}
        </div>
        <div
          className="BookTicketsComponent__DateButton"
          onClick={() =>
            modalActions.showModal('DatePickerModal', {
              date: date,
              maxDate: maxDate,
              onChange: (date) => {
                setDate(date)
                modalActions.hideModal()
              },
            })
          }
        >
          {date.format('DD.MM.YYYY')}
        </div>
      </div>

      <div className="BookTicketsComponent__Button">
        <a
          href={
            'https://www.miniatur-wunderland.' +
            (window.jsProps.lang === 'de' ? 'de' : 'com') +
            '/tickets/booking/' +
            date.format('YYYY-MM-DD')
            // + '/' +
            // numberOfVisitors
          }
          target="_blank"
          className="Cta Cta--icon Cta--icon-ticket"
          rel="noreferrer"
        >
          {window.jsProps.strings.bookTickets}
        </a>
      </div>
    </div>
  )
}

const mapStateToProps = () => ({})

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
  return {
    modalActions: bindActionCreators(modalActionCreators, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(BookTickets)
